module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active is-clipped",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "modal-card",
    attrs: {
      "tabindex": "0",
      "id": _vm.id
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-card-body",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "upper-modal"
  }, [_c('span', [_vm._v("Your Mining Key is:")]), _c('div', {
    staticClass: "conn-id"
  }, [_c('div', {
    staticClass: "hint--bottom",
    attrs: {
      "aria-label": 'Click to copy!'
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.connectionId)
      }
    }
  }, [_vm._v(_vm._s(_vm.connectionId))])])]), _c('div', {
    staticClass: "middle-modal"
  }, [_c('div', {
    staticClass: "description has-text-justify"
  }, [_c('span', [_vm._v("Your Mining Key allows you to simplify your mining configuration by replacing the ")]), _c('span', {
    staticClass: "w600"
  }, [_vm._v("COIN:ADDRESS")]), (_vm.memo) ? _c('span', {
    staticClass: "w600"
  }, [_vm._v(":MEMO ")]) : _c('span', {
    staticClass: "w600"
  }, [_vm._v(" ")]), _c('span', [_vm._v("format. This is useful for old ASICs or third-party mining apps (*) that don’t support the ")]), _c('span', {
    staticClass: "w600"
  }, [_vm._v(": ")]), _c('span', [_vm._v("symbol or have a limited character length.")])]), _c('div', {
    staticClass: "mb-20 description has-text-justify"
  }, [_c('span', [_vm._v("Instead of ")]), _c('span', {
    staticClass: "w600"
  }, [_vm._v(_vm._s(_vm.coin) + ":YourAddress")]), (_vm.memo) ? _c('span', {
    staticClass: "w600"
  }, [_vm._v(":YourMemo")]) : _vm._e(), _c('span', {
    staticClass: "w600"
  }, [_vm._v(".YourWorkerName")]), _c('span', [_vm._v(", use ")]), _c('span', {
    staticClass: "w600"
  }, [_vm._v("MiningKey.YourWorkerName ")]), _c('span', [_vm._v("for easier setup and cleaner configurations. (**)")])]), _c('p', {
    staticClass: "example-container has-text-centered"
  }, [_c('b', {
    staticClass: "wb-ba text-white-on-dark fw-600 fs-15 address-field"
  }, [_vm._v(_vm._s(_vm.coin) + ":" + _vm._s(_vm.address))]), (_vm.memo) ? _c('b', {
    staticClass: "wb-ba text-white-on-dark fw-600 fs-15 address-field"
  }, [_vm._v(":" + _vm._s(_vm.memo))]) : _vm._e(), _c('b', {
    staticClass: "wb-ba text-white-on-dark fw-400 fs-15 address-field light"
  }, [_vm._v(".YourWorkerName")])]), _vm._m(0), _c('p', {
    staticClass: "example-container has-text-centered"
  }, [_c('b', {
    staticClass: "wb-ba text-white-on-dark fw-600 fs-15 address-field"
  }, [_vm._v(_vm._s(_vm.connectionId))]), _c('b', {
    staticClass: "wb-ba text-white-on-dark fw-400 fs-15 address-field light"
  }, [_vm._v(".YourWorkerName")])]), _c('hr'), _vm._m(1)])])]), _c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description has-text-centered"
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description disclaimers"
  }, [_c('div', [_vm._v("(*) Your Mining Key is designed for third-party mining apps or ASICs. Our unMiner app supports mining with addresses only.")]), _c('div', [_vm._v("(**) A worker name isn’t required — you can simply use your Mining Key in your setup and skip specifying a worker name.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b847f94","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_connection_id.vue
// module id = 377
// module chunks = 1